import { MaintainScreen } from "@/app/components/maintain-screen"
import { TopupContainer } from "@/app/containers/topup"
import { ITopupGameDetail } from "@/app/interfaces/ITopup"
import TopupService from "@/app/services/services/TopupService"
import { GetServerSideProps, GetServerSidePropsContext } from "next"
import { i18n, useTranslation, withTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { useRouter } from "next/router"
import React, { useEffect, useState } from "react"

const TopupGameDetailPage = () => {
  const { t } = useTranslation()
  const router = useRouter()
  const [gameDetail, setGameDetail] = useState<ITopupGameDetail>()
  const [maintain, setMaintain] = useState(false)

  const getData = async (slug_name: string) => {
    try {
      const { data } = await TopupService.getInfoGameDetail(slug_name)

      if (data?.data) {
        setGameDetail(data?.data)
      }

      console.log(data)

      if (data.errorCode === 33) {
        setMaintain(true)
      }
    } catch (e: any) {
      if (e.data.errorCode === 33) {
        setMaintain(true)
      }
    }
  }

  useEffect(() => {
    if (!!router?.query?.slug_name) {
      getData(String(router?.query?.slug_name))
    }
  }, [router?.query?.slug_name])

  return (
    <>
      {gameDetail && <TopupContainer gameDetail={gameDetail} />}
      {maintain && <MaintainScreen />}
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  let metaData = {
    title: i18n?.t("seo.shop_title"),
    canonical: `${process.env.NEXT_PUBLIC_HOST_URL}/topup`
  }

  const slug_name = String(context.query?.slug_name)
  try {
    const gameDetail: any = await TopupService.getInfoGameDetail(slug_name)
    if (!!gameDetail) {
      const data = gameDetail?.data?.data
      metaData = {
        ...metaData,
        title: i18n?.t("seo.topup_title", {
          game_name: String(data?.game_name)
        }),
        canonical: `${process.env.NEXT_PUBLIC_HOST_URL}/topup/${slug_name}`
      }
    }
  } catch (err) {}
  return {
    props: {
      isShowRightbar: false,
      isShowTrending: false,
      expandMain: true,
      isShowSidebar: false,
      // use that for fix error serializing
      metaPage: JSON.parse(JSON.stringify(metaData)) || null,
      ...(await serverSideTranslations(context?.locale ?? "vi-VN", ["common"]))
    }
  }
}

export default withTranslation("common")(TopupGameDetailPage)
